import { useDependency } from '@/core/ioc/UseDependency'
import type { ChargerRealTimeEventService } from '@/service/RealTimeEvents/ChargerRealTimeEventService'
import type { CommandRealTimeEventService } from '@/service/RealTimeEvents/CommandRealTimeEventService'
import { ConnectorRealTimeEventService } from '@/service/RealTimeEvents/ConnectorRealTimeEventService'
import type { LocalControllerRealTimeEventService } from '@/service/RealTimeEvents/LocalControllerRealTimeEventService'
import type { SessionRealTimeEventService } from '@/service/RealTimeEvents/SessionRealTimeEventService'
import { SERVICES_TYPES } from '@/service/ServicesTypes'
import { type App } from 'vue'

export default {
  install: (app: App) => {
    const localControllerRealTimeEventService = useDependency<LocalControllerRealTimeEventService>(SERVICES_TYPES.LocalControllerRealTimeEvent)
    app.config.globalProperties.$localControllerRealTimeEventService = localControllerRealTimeEventService
    const chargerRealTimeEventService = useDependency<ChargerRealTimeEventService>(SERVICES_TYPES.ChargerRealTimeEvent)
    app.config.globalProperties.$chargerRealTimeEventService = chargerRealTimeEventService
    const connectorRealTimeEventService = useDependency<ConnectorRealTimeEventService>(SERVICES_TYPES.ConnectorRealTimeEvent)
    app.config.globalProperties.$connectorRealTimeEventService = connectorRealTimeEventService
    const commandRealTimeEventService = useDependency<CommandRealTimeEventService>(SERVICES_TYPES.CommandRealTimeEvent)
    app.config.globalProperties.$commandRealTimeEventService = commandRealTimeEventService
    const sessionRealTimeEventService = useDependency<SessionRealTimeEventService>(SERVICES_TYPES.SessionRealTimeEvent)
    app.config.globalProperties.$sessionRealTimeEventService = sessionRealTimeEventService
  }
}
